import { Card, CardBody, Col } from "reactstrap";
import { TextColorTitle } from "../../../constants";
import { TextColorData, TextColorSubTitle } from "../../../data/uiKits/Typography";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

// Displays different text color classes available in the UI Kit
const TextColor = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={TextColorTitle} span={TextColorSubTitle} />
        <CardBody>
          <div className="d-flex flex-column gap-2">
            {/* Mapping through TextColorData to display different text color classes */}
            {TextColorData &&
              TextColorData.map((item, index) => (
                <p key={index} className={`mb-0 txt-${item.class}`}>
                  {item.text} <code>{`.txt-${item.class}`}</code> {"class"}
                </p>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default TextColor;
